export const EndOngoingSessionModalReducers = (state, action) => {
	switch (action.type) {
		case "TOGGLE_END_ONGOING_SESSION_MODAL":
			return {
				...state,
				open: !state.open
			}
		case "CANCEL_END_ONGOING_SESSION":
			return {
				...state,
				open: false,
				isLoading: false,
				isError: false,
				errorMessage: "",
				message: "",
				isOverMaxMessageLength: false
			}
		case "SET_MESSAGE":
			return {
				...state,
				message: action.payload
			}
		case "SET_OVER_MAX_MESSAGE_LENGTH":
			return {
				...state,
				isOverMaxMessageLength: action.payload
			}
		case "IS_LOADING":
			return {
				...state,
				isLoading: true,
				isError: false,
				errorMessage: ""
			}
		case "POST_SUCCESS":
			return {
				...state,
				isLoading: false,
				isError: false,
				errorMessage: "",
				open: false,
				message: "",
				isOverMaxMessageLength: false
			}
		case "POST_ERROR":
			return {
				...state,
				isLoading: false,
				isError: true,
				errorMessage: action.payload,
				message: "",
				isOverMaxMessageLength: false
			}
		default:
			return state
	}
}
